import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { NetworkTopThreadStartersLoadAction } from '../../domains/networkTopThreadStarters/actions.types';

import { NetworkTopThreadStartersLifecycle } from './types';

const initialState: NetworkTopThreadStartersLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<NetworkTopThreadStartersLifecycle, NetworkTopThreadStartersLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'NETWORK_TOP_THREAD_STARTERS.LOAD_PENDING':
      return setPending();
    case 'NETWORK_TOP_THREAD_STARTERS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.networkTopThreadStarters);
    case 'NETWORK_TOP_THREAD_STARTERS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
